import { defineStyle } from "@chakra-ui/react";

// Self Learn Buttons in Accordion View

export const SelfLearnButtonsAccordionStyles = ({ isMobile }) => {
  return {
    mainContainer: defineStyle({
      display: "flex",
      justifyContent: "flex-start",
      gap: isMobile ? "4px" : "8px",
      paddingTop: "8px",
      flexWrap: "wrap",
    }),
    selfLearnButton: defineStyle({
      width: "max-content",
      height: isMobile ? "auto" : "28px",
      padding: isMobile ? "4px" : "4px 8px",
      gap: "4px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "4px",
      borderWidth: "1px",
      borderColor: "purple.200",
      backgroundColor: "violet.100",
      fontFamily: "Poppins, Text-xs/Semibold",
      fontWeight: "400",
      fontSize: isMobile ? "10px" : "14px",
      lineHeight: isMobile ? "12px" : "18px",
      color: "white.900",
      textAlign: "center",
    }),
    selfLearnImage: defineStyle({
      width: "12px",
      height: "16px",
    }),
    ceaSelfLearnImage: defineStyle({
      width: "20px",
      height: "20px",
    }),
  };
};
